// Open modals in opening order; only the topmost reacts to Escape, and the
// body scroll lock follows the stack instead of each modal's own lifecycle.
const openModalStack: symbol[] = [];

let bodyOverflowBeforeLock = "";

const lockBodyScroll = () => {
  bodyOverflowBeforeLock = document.body.style.overflow;
  document.body.style.overflow = "hidden";
};

const unlockBodyScroll = () => {
  document.body.style.overflow = bodyOverflowBeforeLock;
};

export const registerModal = (modalId: symbol): (() => void) => {
  if (openModalStack.length === 0) {
    lockBodyScroll();
  }
  openModalStack.push(modalId);

  return () => {
    const stackIndex = openModalStack.indexOf(modalId);
    if (stackIndex === -1) {
      return;
    }
    openModalStack.splice(stackIndex, 1);
    if (openModalStack.length === 0) {
      unlockBodyScroll();
    }
  };
};

export const isTopmostModal = (modalId: symbol): boolean =>
  openModalStack[openModalStack.length - 1] === modalId;

export const hasOpenModal = (): boolean => openModalStack.length > 0;
